export class AANDropdownForm {
	init(): void {
		const openDropdownButtons: (HTMLButtonElement | HTMLLabelElement)[] = Array.from(document.querySelectorAll(".dropdown .dropdown-trigger"));

		document.addEventListener("click", () => {
			Array.from(document.querySelectorAll<HTMLElement>(".dropdown .dropdown-content")).forEach((dropdownContent: HTMLElement) => {
				const contentVisibleCheckBox = dropdownContent.parentElement?.querySelector("input.content-visible") as HTMLInputElement;
				dropdownContent.classList.remove("visible");
				if (contentVisibleCheckBox) {
					contentVisibleCheckBox.checked = false;
				}
			});
		});

		openDropdownButtons.forEach(openDropdownButton => {
			const dropdownElement = openDropdownButton.parentElement;
			const dropdownContent = dropdownElement?.querySelector(".dropdown-content") as HTMLElement;
			const contentVisibleCheckBox = dropdownElement?.querySelector("input.content-visible") as HTMLInputElement;

			dropdownElement?.addEventListener("click", e => {
				e.stopPropagation();
			});

			const closeDropdownButtons = Array.from(dropdownElement?.querySelectorAll(".btn-close:not(label), .cancel:not(label), .apply:not(label)") ?? []);

			closeDropdownButtons.forEach(closeDropdownButton => {
				closeDropdownButton.addEventListener("click", () => {
					dropdownContent.classList.remove("visible");
					if (contentVisibleCheckBox) {
						contentVisibleCheckBox.checked = false;
					}
				});
			});

			if (openDropdownButton instanceof HTMLLabelElement && contentVisibleCheckBox) {
				return;
			}

			openDropdownButton.addEventListener("click", () => {
				dropdownContent.classList.add("visible");
				if (contentVisibleCheckBox) {
					contentVisibleCheckBox.checked = false;
				}
			});
		});
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const dropdownForm = new AANDropdownForm();
	dropdownForm.init();
});
